import MonoBehavior from "../../lib/MonoBehavior";
import { Time } from "../../lib/Time";
import SPPlayer from "../SPPlayer";

export default class RegenCore extends MonoBehavior {

    get player(): SPPlayer {return this.gameObject.GetScript(SPPlayer);}

    Update(): void {
        if (this.player.isDead) return;

        if (this.player.hp < this.player.maxHP) {
            this.player.hp += 0.1 * Time.deltaTime;

            if (this.player.hp >= this.player.maxHP) {
                this.player.hp = this.player.maxHP;
            }
        }
    }

}